import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageDialogModel } from '../../../shared/components/message-dialog/message-dialog.component';
import { TourGuideModel } from '../../../models/tour-guide.model';

@Component({
  selector: 'app-tour-guide-dialog',
  templateUrl: './tour-guide-dialog.component.html',
  styleUrls: ['./tour-guide-dialog.component.scss'],
})
export class TourGuideDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TourGuideModel,
    private dialogRef: MatDialogRef<TourGuideDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.dialogRef.updateSize(
      !this.data?.width ? '600px' : this.data?.width,
      !this.data?.height ? '600px' : this.data?.height,
    );
  }

  onAccept() {
    this.dialogRef.close(true);
  }
}
